import { gorgiasTicketSummarySchema } from "@redotech/redo-model/gorgias/gorgias-types";
import * as z from "zod/v4";

export const getDisputeGorgiasTickets = {
  name: "getDisputeGorgiasTickets" as const,
  input: z.object({ disputeId: z.coerce.bigint() }),
  output: z.object({ tickets: z.array(gorgiasTicketSummarySchema) }),
};
